<template>
  <div class="agenda-page">
    <section class="top-section">
      <div class="top-section__content section-content">
        <div class="top-section__left">
          <div class="top-section__title">
            See the full event schedule and explore resources.
          </div>
          <div class="top-section__date">March 10–11</div>
          <div class="top-section__thanks">
            Thank you for joining us. We've got an amazing schedule of events
            we're excited to experience with you!
          </div>
        </div>
        <div class="top-section__right">
          <img src="@/assets/power-one.png" alt="power one" />
        </div>
      </div>
    </section>

    <section class="agenda-section">
      <div class="agenda-section__content section-content">
        <v-row>
          <v-col sm="12" md="2">
            <div class="agenda-section__title">Agenda</div>
          </v-col>
          <v-col sm="12" md="10">
            <AgendaDay
              v-for="agendaDay in agendaDays"
              :key="agendaDay.date"
              :date="agendaDay.date"
              :day="agendaDay.day"
              :items="agendaDay.items"
            />
          </v-col>
        </v-row>
      </div>
    </section>
  </div>
</template>

<script>
import AgendaDay from "@/components/AgendaDay";

export default {
  name: "AgendaPage",
  metaInfo: {
    titleTemplate: "%s - Agenda",
  },
  components: { AgendaDay },
  data() {
    return {
      agendaDays: [
        {
          date: "March 10",
          day: "Wednesday",
          items: [
            {
              time: "12:00–2:00 CT",
              topic: `<b>General Session Day One</b><br>
                <ul>
                <li><b>Welcome by ALSAC President & CEO</b> Rick Shadyac</li>
                <li><b>Town Hall</b></li>
                <li><b>Highlighting Domino’s Partnership & Commitment to St. Jude Children’s Research Hospital</b></li>
                <li><b>P2P Fundraising Trends 2020 & What to Expect in 2021:</b> Kathy Kempff, CEO, Charity Dynamics </li>
                <li><b>St. Jude Hero Feature Story:</b> St. Jude Children’s Research Hospital Feature</li>
                <li><b>In Closing:</b> Evelyn Homs, Sr. Vice President Strategic Partnerships & Multicultural Marketing, ALSAC</li>
                </ul>`,
            },
          ],
        },
        {
          date: "March 11",
          day: "Thursday",
          items: [
            {
              time: "12:00–2:00 CT",
              topic: `<b>General Session Day Two</b><br>
                <ul>
                <li><b>St. Jude Children’s Research Hospital Feature</b></li>
                <li><b>Diversity, Equity & Inclusion in Our Community:</b> Reggie Porter, Sr. Vice President Enterprise Operations, ALSAC and Dr. Brandi Baldwin, Millennial Ventures Holdings</li>
                <li><b>St. Jude Walk/Run Feature Story</b></li>
                <li><b>The Power of One Speaker:</b> Reed Donahue, St. Jude Walk/Run Boston</li>
                <li><b>In Closing:</b> Lynn Page, Vice President Program Strategy & Development, ALSAC</li>
                </ul>`,
            },
            {
              time: "6:30–7:30 CT",
              topic: `<b>Awards Ceremony</b><br/>
                Emcee: Martin Hand, Chief Donor Officer<br/>
                Special Guests: Bridget & Jamie, St. Jude Patient Family<br/>
              `,
            },
          ],
        },
        {
          date: "",
          day: "On Demand Breakout Sessions Available",
          items: [
            {
              topic: `<b>Building and Managing Relationships Virtually</b>`,
            },
            {
              topic: `<b>St. Jude Walk/Run: Committee Experience</b>`,
            },
            {
              topic: `<b>St. Jude Walk/Run: FUNdraising</b>`,
            },
            {
              topic: `<b>St. Jude Walk/Run: Enhanced Digital Experiences</b>`,
            },
            {
              topic: `<b>Good vs. Great Storytelling</b>`,
            },
            {
              topic: `<b>Innovation in Your Community</b>`,
            },
            {
              topic: `<b>Key Ingredients to P2P Email Communication</b>`,
            },
            {
              topic: `<b>Powerful Conversations and Overcoming Objections</b>`,
            },
            {
              topic: `<b>Power of St. Jude Brand and Leveraging Resources on Brand Central</b>`,
            },
            {
              topic: `<b>Secrets to Creating Virtual Event Success</b>`,
            },
            {
              topic: `<b>Social Media Engagement</b>`,
            },
            {
              topic: `<b>St. Jude Heroes Ambassadors</b>`,
            },
            {
              topic: `<b>St. Jude Heroes Experience and Events</b>`,
            },
            {
              topic: `<b>Utilizing LinkedIn as a Community Networking Tool</b>`,
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.top-section {
  background-color: #f5f5f5;
  padding: 90px 75px 100px 120px;

  &__content {
    display: flex;
    align-items: center;
  }

  &__left {
    flex: 1;
    margin-right: 60px;
  }

  &__right {
    > img {
      max-width: 457px;
    }
  }

  &__title {
    font-weight: 800;
    font-size: 64px;
    line-height: 73px;
  }
  &__date {
    font-weight: bold;
    font-size: 43px;
    line-height: 50px;
    margin: 35px 0 45px;
    color: $primary;
  }
  &__thanks {
    font-size: 18px;
    line-height: 24px;
    color: black;
  }
}

.agenda-section {
  padding: 40px 120px 10px;
  background: linear-gradient(0deg, $jude-darkred, $jude-darkred),
    url(~@/assets/ripple.jpg);
  background-blend-mode: multiply, normal;
  mix-blend-mode: darken;
  background-position: center;
  background-size: cover;

  &__title {
    font-weight: bold;
    font-size: 43px;
    line-height: 50px;
    color: white;
  }
}

@media screen and (max-width: 960px) {
  .top-section {
    padding: 35px 20px 50px;
    &__content {
      flex-direction: column-reverse;
    }

    &__left {
      margin-right: 0;
    }

    &__title {
      font-size: 43px;
      line-height: 44px;
      padding-right: 10px;
      margin: 20px 0 10px;
    }

    &__date {
      margin: 10px 0;
    }

    &__right {
      img {
        width: 100%;
      }
    }
  }

  .agenda-section {
    padding: 30px 20px;
    .row {
      flex-direction: column;
    }
  }
}
</style>
